// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {get} from 'lodash';

// Components
import MediaItemOfferingsForm from './mediaitem-offerings-form';
import Permissions from '../core/permissions';
import RecordLocker from './record-locker';

// Containers
import withForm from '../../containers/with-form';

const formName = 'createMediaItemOffering';

class CreateMediaItemOffering extends Component {
    componentDidMount() {
        this.setFormCustomPath();
    }

    componentDidUpdate(nextProps) {
        const {searchValues} = this.props;

        if (searchValues.guid !== nextProps.searchValues.guid) {
            this.setFormCustomPath(nextProps);
        }
    }

    getProps() {
        const {className, searchValues} = this.props;

        return {
            className: classnames(className, 'create-mediaitem-offering'),
            formName,
            onCancelClick: this.handleCancelClick,
            serviceName: get(searchValues, 'service.serviceName'),
        };
    }

    setFormCustomPath(props = this.props) {
        const {setFormCustomPath} = this.props;

        setFormCustomPath(props.searchValues.guid);
    }

    handleCancelClick = () => {
        const {resetForm, setEditCreateState} = this.props;

        resetForm();
        setEditCreateState(true);
    };

    renderRecordLocker() {
        const {searchValues} = this.props;
        const recordId = get(searchValues, 'guid');

        return recordId ? <RecordLocker recordId={recordId} serviceKey="mediaItems" /> : null;
    }

    render() {
        const {searchValues} = this.props;

        return (
            <Permissions
                accessRequirement="write"
                lockAccess={true}
                recordId={searchValues.guid}
                requiresServiceAccess={true}
                serviceKey="mediaItems"
            >
                {this.renderRecordLocker()}
                <MediaItemOfferingsForm {...this.getProps()} />
            </Permissions>
        );
    }
}

CreateMediaItemOffering.propTypes = {
    className: PropTypes.string.isRequired,
    resetForm: PropTypes.func.isRequired,
    searchValues: PropTypes.object.isRequired,
    setEditCreateState: PropTypes.func.isRequired,
    setFormCustomPath: PropTypes.func.isRequired,
};

export default withForm(CreateMediaItemOffering, formName);
